module.exports = __webpack_public_path__ + "030ff6b155463beefa9e9e325b3881a6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gallery/ii/ii08.jpg
// module id = 654
// module chunks = 0